import UserActionsActionType from './userActionsActionType';

export const getUserActions = (params) => ({
  type: UserActionsActionType.GET_USER_ACTIONS,
  payload: { params },
});

export const saveUserActions = (data) => ({
  type: UserActionsActionType.SAVE_USER_ACTIONS,
  payload: { data },
});

export const resetUserActions = () => ({
  type: UserActionsActionType.RESET_USER_ACTIONS,
});

export const getUserRecentActions = (params) => ({
  type: UserActionsActionType.GET_USER_RECENT_ACTIONS,
  payload: { params },
});

export const saveUserRecentActions = (data) => ({
  type: UserActionsActionType.SAVE_USER_RECENT_ACTIONS,
  payload: { data },
});

export const resetUserRecentActions = () => ({
  type: UserActionsActionType.RESET_USER_RECENT_ACTIONS,
});
